import { theme } from '@healingpaper/cell'

import { ColorSet } from './color'
import { TypographySet } from './typography'

export interface CellTheme {
  colors: ColorSet
  typography: TypographySet
}

const cellTheme = {
  ...theme,
}

export default cellTheme
